import React from 'react';

export default function Home() {
  return (
    <main style={styles.container}>
        <h1>About Me</h1>
        <p>I help teams build scalable, cloud-native applications.</p>
    </main>
  );
}

const styles = {
    container: {
      fontFamily: 'sans-serif',
      maxWidth: '600px',
      margin: '2rem auto',
      padding: '1rem',
      lineHeight: 1.6
    },
    heading: {
      fontSize: '2.5rem',
      marginBottom: '0.2rem'
    },
  };
  